module.exports = __webpack_public_path__ + "static/img/wdys1-5.1787c5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdys1-5.png
// module id = 893
// module chunks = 0